enum DocumentReadyStateEnum {
	loading = 'loading',
	interactive = 'interactive',
	complete = 'complete'
}
export default DocumentReadyStateEnum;
